require('date');
//
ko.bindingHandlers.date = {
    init: function (element, valueAccessor, allBindings) {
        var value = valueAccessor();
        var valueUnwrapped = ko.unwrap(value);
        var type = allBindings.get('type') || 'datetime';
        if (type === 'date') {
            var date = Date._jfparse(valueUnwrapped);
            $(element).text(date._jfdf('yyyy-MM-dd'));
        } else {
            $(element).text(valueUnwrapped);
        }
    }
}
// 需要绑定enter按键的元素：input textarea
ko.bindingHandlers.enter = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        var allBindings = allBindings();
        if ($.isFunction(allBindings.enter) && $(element).is('input,textarea')) {
            $(element).keypress(function (e) {
                var keyCode = e.which || e.keyCode;
                if (keyCode === 13) {
                    allBindings.enter.call(viewModel, viewModel, e);
                }
            })
        }
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./lib/ko-ext.js
 ** module id = 118
 ** module chunks = 4
 **/